const KB = 1024;
const MB = KB * 1024;

export function formatFileSize(size: number, fractionDigits = 2) {
  let res = (size / MB).toFixed(fractionDigits);
  while (res.length > 1 && res.lastIndexOf('0') === res.length - 1) {
    res = res.slice(0, -1);
  }
  res = res.replace('.', ',');
  return `${res}MB`;
}
